import React from 'react';
import { getFormattedSpendWithSymbol } from 'utils/number';

import {
	CollapsibleContainer,
	CollapsibleHeader,
	CollapsibleButton,
	CollapsibleHeaderTitle,
	CollapsibleHeaderValue,
	CollapsibleContent,
	InitiativeRow,
} from './Planner.styles';

const CollapsibleWave = ({ currencySymbol, wave, initiatives, searchInitiative, isExpanded, setIsExpanded }) => {
	const waveLow = initiatives.reduce((acc, initiative) => acc + initiative.low, 0);
	const waveHigh = initiatives.reduce((acc, initiative) => acc + initiative.high, 0);
	const isWaveFaded = searchInitiative && searchInitiative.waveId !== wave.id;
	return (
		<CollapsibleContainer>
			<CollapsibleHeader isFaded={isWaveFaded}>
				<CollapsibleButton
					iconProps={{ iconSize: 24 }}
					iconName='baseline_keyboard_arrow_down'
					isExpanded={isExpanded}
					onClick={setIsExpanded}
				/>
				<CollapsibleHeaderTitle>{wave.name}</CollapsibleHeaderTitle>
				<CollapsibleHeaderValue>{getFormattedSpendWithSymbol(waveLow, currencySymbol)}</CollapsibleHeaderValue>
				<CollapsibleHeaderValue>{getFormattedSpendWithSymbol(waveHigh, currencySymbol)}</CollapsibleHeaderValue>
			</CollapsibleHeader>
			{isExpanded ? (
				<CollapsibleContent>
					{initiatives.map(initiative => (
						<InitiativeRow key={initiative.id} isFaded={searchInitiative && searchInitiative.id !== initiative.id}>
							<CollapsibleHeaderTitle
								title={initiative.name}
							>
								{initiative.name}
							</CollapsibleHeaderTitle>
							<CollapsibleHeaderValue>{getFormattedSpendWithSymbol(initiative.low, currencySymbol)}</CollapsibleHeaderValue>
							<CollapsibleHeaderValue>{getFormattedSpendWithSymbol(initiative.high, currencySymbol)}</CollapsibleHeaderValue>
						</InitiativeRow>
					))}
				</CollapsibleContent>
			) : null}
		</CollapsibleContainer>
	);
};

export default CollapsibleWave;


